import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { featureApprovalSaga, setFeatureApprovalSaga } from './featureApprovalSaga';

export function* featureSaga() {
  yield takeLatest(sagaActions.GET_FEATURE_DATA, featureApprovalSaga);
  yield takeLatest(sagaActions.SET_FEATURE_DATA, setFeatureApprovalSaga);
}
